import { z } from "zod";
/** The trades GigSync lists. A worker offers one or more; a consumer asks for exactly one. */
export const Trade = z.enum([
    "electrician",
    "plumber",
    "maid",
    "carpenter",
    "ac_technician",
    "painter",
    "cook",
    "driver",
]);
/**
 * A job's kind of work (ADR 0047): one of the trades, or `other` for a skill a worker lists in their own words. A job
 * of `other` carries its `Skill`; it has no price drivers, scope buckets or estimate, and the generic questions.
 */
export const JobTrade = z.enum([...Trade.options, "other"]);
/** True for one of the trades, which have price questions and estimates; false for `other`. */
export const isTrade = (work) => work !== JobTrade.enum.other;
//# sourceMappingURL=trade.js.map